var map = {
	"./parachute 1.jpg": 89344,
	"./parachute.jpg": 14365,
	"./rat 1.jpg": 6832,
	"./rocket 01.jpg": 65309,
	"./rocket 2.jpg": 25920,
	"./rocket 3.jpg": 77661,
	"./rocket.jpg": 12186,
	"./stilite 2.jpg": 63920,
	"./stilite 3.jpg": 32493,
	"./zirafee 1.jpg": 65241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35176;